/**
 *  Egaline Totaal — PDP-gedrag
 *  1. Actieve staffelrij highlighten o.b.v. het gekozen aantal
 *  2. CTA-totaal in de koopknoppen ("In winkelwagen · € 132,50")
 *  3. Sticky-stepper synchroon houden met de hoofdstepper
 *  4. "Neem over" in de verbruikscalculator zet het advies in de stepper
 *  Alles defensief: elementen kunnen ontbreken (quick-view/featured-product).
 */
(function () {
  'use strict';

  function init() {
    var configEl = document.querySelector('[data-et-pdp-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }

    var sectionId = config.sectionId;
    var price = parseInt(config.price, 10) || 0;
    var ctaCart = config.ctaCart || '';

    /* Koopregel: stepper + CTA + WhatsApp in één flex-rij zetten (markup-blokken
       zijn losse grid-kinderen met theme-elementen ertussen; CSS-grid bleek
       daardoor fragiel). Zonder JS stapelen de blokken gewoon. */
    (function bouwKoopregel() {
      var qty = document.getElementById('quantity-' + sectionId);
      var addBtn = document.getElementById('AddToCart');
      var formWrap = addBtn ? addBtn.closest('.product-information--inner > div, div') : null;
      while (formWrap && formWrap.parentElement && !formWrap.parentElement.classList.contains('product-information--inner')) {
        formWrap = formWrap.parentElement;
      }
      var trust = document.querySelector('.product-information--inner > .product-trust-strip-container');
      if (!qty || !formWrap || !formWrap.parentElement) return;
      var rij = document.createElement('div');
      rij.className = 'et-pdp-koopregel';
      qty.parentElement.insertBefore(rij, qty);
      rij.appendChild(qty);
      rij.appendChild(formWrap);
      if (trust) rij.appendChild(trust);
    })();

    var staffel = document.querySelector('[data-et-staffel]');
    var rows = staffel ? Array.prototype.slice.call(staffel.querySelectorAll('.et-pdp-staffel--rij')) : [];
    /* Rekent de winkel de staffelprijs zelf af? De bron staat in
       snippets/product-staffelblok.liquid (assign staffel_automatisch); die
       schrijft het hier als data-attribuut neer. Vandaag: nee. De winkel heeft
       geen enkele aantalsafhankelijke automatische korting (nagetrokken
       08-09-2026), dus rekende deze knop "In winkelwagen · € 530,00" voor 40
       zakken die in de winkelwagen 547,60 kosten. Het CTA-totaal volgt daarom
       de gewone variantprijs; de staffelrijen blijven staan als informatie,
       met de noot eronder dat de prijs op aanvraag is. */
    var staffelAutomatisch = !!staffel && staffel.getAttribute('data-staffel-auto') === 'true';

    function getQtyInput() {
      return document.getElementById('Quantity-' + sectionId);
    }

    function getStickyQtyInput() {
      return document.querySelector('.et-pdp-sticky-qty .qty');
    }

    function getButtons() {
      return [document.getElementById('AddToCart'), document.getElementById('AddToCartSticky')].filter(Boolean);
    }

    function getQty() {
      var input = getQtyInput();
      var value = input ? parseInt(input.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    /* Geen euroteken: de winkel staat op moneyFormat
       "{{amount_with_comma_separator}}", dus elke prijs die Liquid met de
       money-filter rendert komt zonder symbool binnen. Jan (11-09-2026):
       euroteken mag overal weg. Deze functie volgde dat niet en zette er als
       enige plek op de PDP wél een € voor. */
    function fmt(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    }

    function activeRow(quantity) {
      var match = null;
      rows.forEach(function (row) {
        var min = parseInt(row.getAttribute('data-min'), 10);
        var max = parseInt(row.getAttribute('data-max'), 10);
        if (quantity >= min && (isNaN(max) || quantity <= max)) match = row;
      });
      return match;
    }

    function unitPrice(quantity) {
      if (!staffelAutomatisch) return price;
      var row = activeRow(quantity);
      if (row && row.hasAttribute('data-staffel-prijs')) {
        var rowPrice = parseInt(row.getAttribute('data-staffel-prijs'), 10);
        if (rowPrice > 0) return rowPrice;
      }
      return price;
    }

    function buttonIsBuyable(button) {
      if (button.disabled || button.classList.contains('sold-out')) return false;
      var form = button.closest('.product-form');
      var template = form ? form.getAttribute('template') : '';
      if (template && template.indexOf('pre-order') !== -1) return false;
      return true;
    }

    function removeCta(button) {
      var span = button.querySelector('.et-pdp-cta');
      if (span) span.parentNode.removeChild(span);
      button.classList.remove('et-pdp-cta-active');
    }

    function ctaSpan(button) {
      var span = button.querySelector('.et-pdp-cta');
      if (!span) {
        span = document.createElement('span');
        span.className = 'et-pdp-cta';
        var native = button.querySelector('.single-add-to-cart-button--text');
        if (native && native.parentNode) {
          native.parentNode.insertBefore(span, native.nextSibling);
        } else {
          button.appendChild(span);
        }
        button.classList.add('et-pdp-cta-active');
      }
      return span;
    }

    function render() {
      var quantity = getQty();
      var current = activeRow(quantity);
      rows.forEach(function (row) {
        row.classList.toggle('is-actief', row === current);
      });

      getButtons().forEach(function (button) {
        if (!buttonIsBuyable(button)) {
          removeCta(button);
          return;
        }
        var span = ctaSpan(button);
        span.textContent = ctaCart + ' · ' + fmt(unitPrice(quantity) * quantity);
      });

      var stickyInput = getStickyQtyInput();
      if (stickyInput && parseInt(stickyInput.value, 10) !== quantity) {
        stickyInput.value = quantity;
      }
    }

    // Aantal-wijzigingen (delegatie: het quantity-blok wordt bij variantwissel vervangen)
    function onQtyEvent(event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('input.qty')) return;
      var stickyInput = getStickyQtyInput();
      if (target === stickyInput) {
        var value = parseInt(target.value, 10);
        var mainInput = getQtyInput();
        if (mainInput && value > 0 && parseInt(mainInput.value, 10) !== value) {
          mainInput.value = value;
          mainInput.dispatchEvent(new Event('change', { bubbles: true }));
          return; // render volgt via het change-event van de hoofdstepper
        }
      } else if (target !== getQtyInput()) {
        return;
      }
      render();
    }
    document.addEventListener('change', onQtyEvent);
    document.addEventListener('input', onQtyEvent);

    // Verbruikscalculator: "Neem over" zet het advies in de stepper
    document.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest ? event.target.closest('[data-calculator-neem-over]') : null;
      if (!trigger) return;
      var calculator = trigger.closest('verbruik-calculator');
      var resultValue = calculator ? calculator.querySelector('[data-calculator-result-value]') : null;
      var advies = resultValue ? parseInt(resultValue.textContent, 10) : 0;
      var mainInput = getQtyInput();
      if (!mainInput || !(advies > 0)) return;
      mainInput.value = advies;
      mainInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Variantwissel: het thema (product.js/renderProductInfo) vervangt het
    // quantity-blok asynchroon en zet de knop tijdens de fetch op disabled.
    // Eén directe render() is dan niet genoeg: het CTA-totaal verdwijnt en
    // komt pas bij de volgende aantal-interactie terug. We kijken daarom kort
    // mee met een MutationObserver (met einde na 4s) en renderen opnieuw
    // zodra het nieuwe quantity-blok en de knop-state er staan.
    var swapObserver = null;
    var swapTimeout = null;

    function stopSwapWatch() {
      if (swapObserver) {
        swapObserver.disconnect();
        swapObserver = null;
      }
      if (swapTimeout) {
        clearTimeout(swapTimeout);
        swapTimeout = null;
      }
    }

    function startSwapWatch() {
      stopSwapWatch();
      var targets = ownButtons.slice();
      var qtyWrap = document.getElementById('quantity-' + sectionId);
      if (qtyWrap) targets.push(qtyWrap);
      if (!targets.length) return;

      var options = { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] };
      var observer = new MutationObserver(function () {
        if (swapObserver !== observer) return;
        // eigen render-mutaties niet observeren (voorkomt een observer-lus)
        observer.disconnect();
        render();
        if (swapObserver === observer) {
          targets.forEach(function (el) {
            observer.observe(el, options);
          });
        }
      });
      targets.forEach(function (el) {
        observer.observe(el, options);
      });
      swapObserver = observer;
      swapTimeout = setTimeout(stopSwapWatch, 4000);
    }

    document.addEventListener('product:variant-change', function (event) {
      // basisprijs-fallback actueel houden
      if (event.detail && event.detail.variant && typeof event.detail.variant.price === 'number') {
        price = event.detail.variant.price;
      }
      render(); // directe stand (staffelrijen + sticky-waarde) alvast bijwerken
      startSwapWatch();
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
